import React, { useEffect, useState } from "react";
import { ProfileDialog as ProfileDialogComponent } from "../../components";
import auth from "services/Auth";

import _merge from "lodash/merge";
import _pick from "lodash/pick";

const ProfileDialog = (props) => {
  const [profile, setProfile] = useState("");
  const [mode, setMode] = useState("load");

  const handleVerifyEmail = (factor) => {
    const email = props.profile.new_email_addr || props.profile.email;
    auth
      .verifyemail(factor, email)
      .then((succcess) => {
        setProfile((prevAttributes) => ({
          ...prevAttributes,
          verified_email: email,
        }));
      })
      .catch((error) => {});
  };
  const handleVerifyPhone = (factor) => {
    auth
      .verifyemail(factor, profile.email, profile.phone)
      .then((succcess) => {
        setProfile((prevAttributes) => ({
          ...prevAttributes,
          verified_phone: profile.phone,
        }));
      })
      .catch((error) => {});
  };
  const handleSave = (attrs) =>
    auth
      .patchUserProfile(attrs)
      .then(() => {
        console.log("SAVED");
        setMode("edit");
        return [true];
      })
      .catch((error) => {
        console.log("ERROR", error);
        return [false, error.message];
      });
  const handleChange = (key, value) => {
    setMode("changed");
    setProfile((prevAttributes) => ({
      ...prevAttributes,
      [key]: value,
    }));
  };
  const refetchProfile = (attrs) => {
    auth
      .userProfile()
      .then((result) => {
        if (attrs?.length > 0) {
          setProfile((current) => {
            const updated = _merge({ ...current }, _pick(result, attrs));
            return updated;
          });
        } else {
          setProfile(profile);
        }
        setMode("edit");
      })
      .catch((error) => {
        console.error("Error fetching attributes:", error);
      });
  };

  useEffect(() => {
    auth
      .userProfile()
      .then((profile) => {
        setProfile(profile);
        setMode("edit");
      })
      .catch((error) => {
        console.error("Error fetching attributes:", error);
      });
  }, []);

  if (mode === "load") {
    // return <div>Loading...</div>;
    return null;
  }

  return (
    <ProfileDialogComponent
      profile={profile}
      setProfile={setProfile}
      refetchProfile={refetchProfile}
      verifyPhone={handleVerifyPhone}
      verifyEmail={handleVerifyEmail}
      changeProp={handleChange}
      save={handleSave}
      open={props.open}
      close={props.close}
      mode={mode}
    />
  );
};

export default ProfileDialog;
